document.addEventListener('DOMContentLoaded', function () {

  const params = new URLSearchParams(window.location.search);
  const email = params.get('email');

  if (!email) return;

  const fillForms = setInterval(function () {

    /* FORM STANDARD */
    const normalFields = document.querySelectorAll(
      'input[type="email"], input[name="email"], input[name="$email"]'
    );

    normalFields.forEach(function(field) {

      if (field.dataset.filled) return;

      field.value = email;

      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));

      field.dataset.filled = 'true';
    });


    /* POPUP KLAVIYO */
    const klaviyoForm = document.querySelector(
      'form[data-testid="klaviyo-form-VnYiri"]'
    );

    if (klaviyoForm) {

      const popupEmail = klaviyoForm.querySelector(
        'input[type="email"]'
      );

      if (popupEmail && !popupEmail.dataset.filled) {

        popupEmail.value = email;

        popupEmail.dispatchEvent(
          new Event('input', { bubbles: true })
        );

        popupEmail.dispatchEvent(
          new Event('change', { bubbles: true })
        );

        popupEmail.dataset.filled = 'true';
      }
    }

  }, 300);

  setTimeout(function () {
    clearInterval(fillForms);
  }, 10000);

});